import { lexonHttp } from '@/plugins/axios/lexonHttp'

export class ContactsService {
  constructor() {}

  getData(url: string) {
    return lexonHttp.get(url)
  }
}
